import { render, staticRenderFns } from "./svg-close.vue?vue&type=template&id=4c8b8838&"
import script from "./svg-close.vue?vue&type=script&lang=js&"
export * from "./svg-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports